module.exports = __webpack_public_path__ + "static/media/outside1.08e2278f.png";